import { throwError as observableThrowError, of as observableOf, Observable } from 'rxjs';

import { refCount, publishReplay, catchError } from 'rxjs/operators';
import { Injectable } from '@angular/core';

import { ResourceService } from '../../resource/resource.service';


@Injectable({
    providedIn: 'root'
})
export class ConfigurationResourceService {
    private cache = new Map<string, Observable<any>>();

    constructor(
        private resourceService: ResourceService
    ) {
    }

    public get<TConfig>(path: string[], defaultValue?: TConfig): Observable<TConfig> {
        const cacheKey = path.join();
        if (!this.cache.has(cacheKey)) {
            const asyncResult = this.resourceService.get(
                this.resourceService.getUrl(...path)
            ).pipe(
                catchError((error: Error) => {
                    if (defaultValue !== undefined) {
                        return observableOf(defaultValue);
                    }

                    return observableThrowError(error);
                }),
                publishReplay(1),
                refCount(),
            );

            this.cache.set(cacheKey, asyncResult);
        }
        return this.cache.get(cacheKey) as Observable<TConfig>;
    }
}